import { styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

import { ReactComponent as EmptyStateIcon } from 'assets/icons/emptyState.svg';
import { TaskStatus } from 'types';

export const EmptyStateW = styled('div')<{ status?: TaskStatus }>`
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  width: 100%;
  padding: 16px;
  color: ${({ theme }) => theme.palette.primary.p040};
  background-color: ${({ theme }) => theme.palette.white.main};
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};

  @media (max-width: 1023px) {
    border-radius: 16px;
    border: 0px;
    align-self: center;
    padding: 24px;
    border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  }
`;

export const NavLinkW = styled(NavLink)`
  color: ${({ theme }) => theme.palette.info.main};
  margin-left: 3px;
`;

export const EmptyStateIconW = styled(EmptyStateIcon)`
  margin-bottom: 17px;
`;

export const Description = styled(Typography)`
  font-size: 14px;
  line-height: 18px;
`;
